import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import ContactPage from '@/components/ContactPage'
import LoginPage from '@/components/LoginPage'
import VitrinePanel from '@/components/ServicePanels/VitrinePanel'
import EcommercePanel from '@/components/ServicePanels/EcommercePanel'
import AppGestionPanel from '@/components/ServicePanels/AppGestionPanel'
import StratDigitalePanel from '@/components/ServicePanels/StratDigitalePanel'
import AutresProjetsPanel from '@/components/ServicePanels/AutresProjetsPanel'
import Services from '@/components/Services'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      meta: {title: 'Simon Vasseur - Développeur Web indépendant'},
      children: [
        {
          path: '/',
          name: "Services",
          component: Services,
          meta: {title: 'Simon Vasseur - Développeur Web indépendant'}
	      },
	      {
          path: 'vitrine',
          name: "VitrinePanel",
          component: VitrinePanel,
          meta: {title: 'Simon Vasseur - Développeur Web indépendant'}
        },
        {
          path: 'ecommerce',
          name: "EcommercePanel",
          component: EcommercePanel,
          meta: {title: 'Simon Vasseur - Développeur Web indépendant'}
        },
        {
          path: 'gestion',
          name: "AppGestionPanel",
          component: AppGestionPanel,
          meta: {title: 'Simon Vasseur - Développeur Web indépendant'}
        },
        {
          path: 'digital',
          name: "StratDigitalePanel",
          component: StratDigitalePanel,
          meta: {title: 'Simon Vasseur - Développeur Web indépendant'}
        },
        {
          path: 'projets',
          name: "AutresProjetsPanel",
          component: AutresProjetsPanel,
          meta: {title: 'Simon Vasseur - Développeur Web indépendant'}
        }
      ],
    },
    {
      path: '/contact',
      name: 'ContactPage',
      component: ContactPage,
      meta: {title: 'Simon Vasseur - Développeur Web indépendant'},
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
      meta: {title: 'Simon Vasseur - Développeur Web indépendant'},
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js